<template>
  <div class="page flex-col">
    <headerNav :initialSelectedIndex="currentSelectedIndex" @update:selectedIndex="updateSelectedIndex" />

    <div class="content flex-col">
      <div class="box_2 flex-col">
        <div class="box_3 flex-row justify-between">
          <span class="text_9">新闻动态</span>
          <img class="image_1" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng9e1a2cb3a182f30d530ffc5513d1dfb64b59882f44e91958744b04c3aeab0a3b.png" />
        </div>

        <div class="box_4 flex-row">
          <span class="text_10">news&nbsp;information</span>
          <img class="image_2" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngfa77dfe3a27b34ab0fe1ba7ab5dbbb513e31394b862d03ba6f6f9a407daa7ea4.png" />
          <img class="image_3" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng957dd1dc6eddd674b0817d79707b8ebba9c1e962c1170837444e7843d4f9a593.png" />
        </div>
        <img class="image_4" referrerpolicy="no-referrer"
          src="./assets/img/SketchPnga772c7513e43688a65463086833268af393acee7e6b2335678e893a567d177f8.png" />
      </div>

      <div class="content">


        <div style="width: 60%;font-size:14px" v-html="rawHtml"></div>



      </div>


    </div>
    <bottomNav />
  </div>
</template>
<script>
import headerNav from "../../components/headerNav.vue"; // 导入 HeaderNav 组件
import bottomNav from "../../components/bottomNav.vue"; // 导入 bottomNav 组件
import axios from 'axios';
//const API_URL = '/data.json';

export default {
  components: {
    headerNav,
    bottomNav,
  },
  data() {
    return {
      currentSelectedIndex: 6, // 默认选中“新闻动态”

      rawHtml:""

    };
  },
  methods: {
    updateSelectedIndex(index) {
      this.currentSelectedIndex = index; // 更新选中的索引
    },

    async fetchData(id) {
      try {


        /*const response = await axios.get('http://110.41.186.173:8011/cms/blog/cms/detail/'+id);*/
        const response = await axios.get('https://www.linli-tech.cn/api/cms/blog/cms/detail/'+id);

        console.log(response)
        if (response.data.data.content){
          this.rawHtml=response.data.data.content;
        }else{
          this.rawHtml="<img src="+"https://linli-99.obs.cn-east-3.myhuaweicloud.com"+response.data.data.blogPic+">";
        }


        return response;
      } catch (error) {
        console.error('请求失败:', error);
        return "";
      }
    }
  },


  created(){

    console.log(this.$route.query.id)
    this.fetchData(this.$route.query.id)
  },

  computed: {
    totalPages() {
      return Math.ceil(this.articles.length / this.pageSize);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.articles.slice(start, start + this.pageSize);
    }
  },
};
</script>
<style scoped lang="css" src="./assets/index.css" />
